import React from "react";
import DateRangeChip from "../../common/DateRangeChip";
import { DateRangePreset } from "../../../types/reports";

interface Props {
  preset: DateRangePreset;
  customStart: string | null;
  customEnd: string | null;
  onChange: (
    preset: DateRangePreset,
    customStart: string | null,
    customEnd: string | null,
  ) => void;
}

/**
 * Date filter styled as a Sales filter pill (like the Status/Client pills) but
 * opening the reports date-range menu (presets + custom range) as its contents.
 * A thin wrapper over the app-wide `common/DateRangeChip` it was promoted to.
 */
export default function SalesDateRangePill({
  preset,
  customStart,
  customEnd,
  onChange,
}: Props) {
  return (
    <DateRangeChip
      label="Date"
      preset={preset}
      customStart={customStart}
      customEnd={customEnd}
      onChange={onChange}
    />
  );
}
